__turbopack_context__.v({
  "countdown": "CountdownDisplay-module__vood8q__countdown",
  "label": "CountdownDisplay-module__vood8q__label",
  "value": "CountdownDisplay-module__vood8q__value",
});
